import { combineReducers } from "@reduxjs/toolkit";
import menuListReducer from "./menu-list";

const menuReducer = combineReducers({
  menuList: menuListReducer,
});

export { menuReducer };
